import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export default class FromRawdataToAdvertisingValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.advertisingAdsListMapper
   * @param {Object} param.advertisingAdsDetailMapper
   * @param {Object} param.advertisingNewsListMapper
   * @param {Object} param.advertisingNewsDetailMapper
   * @param {Object} param.advertisingGenericMapper
   */
  constructor({
    config,
    advertisingAdsListMapper,
    advertisingAdsDetailMapper,
    advertisingAdsDetailGalleryMapper,
    advertisingNewsListMapper,
    advertisingNewsDetailMapper,
    advertisingGenericMapper,
    fromTechnicalDetailsPageDataToAdvertisingValueObjectMapper
  }) {
    super()

    this._pageConfig = config.get('page')
    this._advertisingGenericMapper = advertisingGenericMapper
    this._advertisingAdsListMapper = advertisingAdsListMapper
    this._advertisingAdsDetailMapper = advertisingAdsDetailMapper
    this._advertisingAdsDetailGalleryMapper = advertisingAdsDetailGalleryMapper
    this._advertisingNewsListMapper = advertisingNewsListMapper
    this._advertisingNewsDetailMapper = advertisingNewsDetailMapper
    this._advertisingTechnicalDetailsMapper = fromTechnicalDetailsPageDataToAdvertisingValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.pageName
   * @param {String} param.search
   * @param {String} param.category
   * @param {String} param.tag
   * @param {String} param.searchTerm
   * @param {String} param.section
   * @param {String} param.ad
   * @param {String} param.adType
   * @param {String} param.seller
   * @param {String} param.companyIdWas
   * @returns {Function}
   */
  map({
    ad,
    adType,
    bodyType,
    category,
    companyIdWas,
    fuelType,
    make,
    model,
    pageName,
    search,
    searchTerm,
    section,
    seller,
    tag
  }) {
    switch (pageName) {
      case this._pageConfig.ADS_LIST_PAGE_NAME:
      case this._pageConfig.ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME:
      case this._pageConfig.ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME:
      case this._pageConfig.ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME:
      case this._pageConfig.ADS_LIST_BUGGIES_PAGE_NAME:
      case this._pageConfig.ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME:
      case this._pageConfig.ADS_LIST_MINIMOTOS_PAGE_NAME:
      case this._pageConfig.ADS_LIST_QUADS_PAGE_NAME:
      case this._pageConfig.ADS_LIST_NEW_PAGE_NAME:
      case this._pageConfig.ADS_LIST_BUGGIES_NEW_PAGE_NAME:
      case this._pageConfig.ADS_LIST_MINIMOTOS_NEW_PAGE_NAME:
      case this._pageConfig.ADS_LIST_QUADS_NEW_PAGE_NAME:
      case this._pageConfig.ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME:
      case this._pageConfig.ADS_LIST_SUBSCRIPTION_PAGE_NAME: {
        return this._advertisingAdsListMapper.setParams({pageName}).map({search})
      }
      case this._pageConfig.ADS_DETAIL_PAGE_NAME:
      case this._pageConfig.ADS_DETAIL_PREVIEW_PAGE_NAME: {
        return this._advertisingAdsDetailMapper.map({
          ad,
          adType,
          seller,
          companyIdWas
        })
      }
      case this._pageConfig.ADS_DETAIL_GALLERY_PAGE_NAME: {
        return this._advertisingAdsDetailGalleryMapper.map({
          ad,
          adType,
          seller,
          companyIdWas
        })
      }
      case this._pageConfig.NEWS_CATEGORY_PAGE_NAME:
      case this._pageConfig.NEWS_TAG_PAGE_NAME:
      case this._pageConfig.NEWS_SEARCH_PAGE_NAME:
      case this._pageConfig.NEWS_SECTION_TIPS_PAGE_NAME:
      case this._pageConfig.NEWS_SECTION_TRENDS_PAGE_NAME: {
        return this._advertisingNewsListMapper.map({
          category,
          tag,
          searchTerm,
          section
        })
      }
      case this._pageConfig.NEWS_COMMENTS_PAGE_NAME:
      case this._pageConfig.NEWS_DETAIL_PAGE_NAME: {
        return this._advertisingNewsDetailMapper.map({
          category,
          make,
          model
        })
      }
      case this._pageConfig.TECHNICAL_DETAILS_MAKE_PAGE_NAME:
      case this._pageConfig.TECHNICAL_DETAILS_MODEL_PAGE_NAME:
      case this._pageConfig.TECHNICAL_DETAILS_VEHICLE_PAGE_NAME:
      case this._pageConfig.TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME: {
        return this._advertisingTechnicalDetailsMapper.map({
          bodyType,
          fuelType,
          make,
          model,
          pageName
        })
      }
      default:
        return this._advertisingGenericMapper.map({pageName})
    }
  }
}
